import { render } from "./OrientationAssessement.vue?vue&type=template&id=0e253ab3"
import script from "./OrientationAssessement.vue?vue&type=script&lang=js"
export * from "./OrientationAssessement.vue?vue&type=script&lang=js"

import exportComponent from "/Users/macbookpro/Herd/hris-laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__